import { Text as MantineText } from "@mantine/core";
import { ResponsiveRadar } from "@nivo/radar";
import { useEffect, useState } from "react";

const MAXSEG = 50;

/* eslint-disable @typescript-eslint/no-explicit-any */
//prettier-ignore
const legends: Array<{
  anchor: "top" | "top-left" | "top-right" | "bottom" | "bottom-left" | "bottom-right" | "left" | "right" | "center";
  direction: "row" | "column";
  translateX?: number;
  translateY?: number;
  itemWidth: number;
  itemHeight: number;
  itemTextColor?: string;
  symbolSize?: number;
  symbolShape?: "circle" | "square" | "diamond";
}> = [
    {
      anchor: "top-left",
      direction: "column",
      translateX: -50,
      translateY: -40,
      itemWidth: 80,
      itemHeight: 20,
      itemTextColor: "#999",
      symbolSize: 12,
      symbolShape: "circle"
    }
  ];

type DataItem = {
  segment: string;
  value: number;
};

type Dataset = {
  id: string;
  data: DataItem[];
};

type Properties = {
  segments: string[];
  datasets: Dataset[];
  texto: string;
};

type RadarDataSegment = {
  segment: string;
  [key: string]: number | string;
};

/**
 * Componente RadarNota
 * @param root0 Propriedades do componente
 * @param root0.datasets Dados do radar
 * @param root0.segments Segmentos do radar
 * @param root0.texto - Texto do radar
 * @returns Componente
 */
function RadarNota({ datasets, segments, texto }: Properties) {
  const [radarData, setRadarData] = useState<RadarDataSegment[]>([]);
  const [datasetsIds, setDatasetsIds] = useState<string[]>([]);

  useEffect(() => {
    const segmentsDataMap = new Map<string, RadarDataSegment>();

    for (const dataset of datasets) {
      for (const dataItem of dataset.data) {
        const nomeSegumento =
          dataItem.segment.length > MAXSEG ? `${dataItem.segment.slice(0, MAXSEG)}...` : dataItem.segment;
        const segmentData = segmentsDataMap.get(nomeSegumento);
        if (segmentData) {
          segmentData[dataset.id] = dataItem.value;
          segmentsDataMap.set(nomeSegumento, segmentData);
        } else {
          segmentsDataMap.set(nomeSegumento, { segment: nomeSegumento, [dataset.id]: dataItem.value });
        }
      }
    }

    setDatasetsIds(datasets.map((dataset) => dataset.id));
    setRadarData([...segmentsDataMap.values()]);
  }, [datasets, segments]);

  return (
    <>
      <MantineText>{texto}</MantineText>
      <ResponsiveRadar
        data={radarData}
        keys={datasetsIds}
        indexBy="segment"
        valueFormat=">-.2f"
        maxValue={100}
        margin={{ top: 70, right: 80, bottom: 70, left: 80 }}
        gridLabelOffset={36}
        dotSize={10}
        dotColor={{ theme: "background" }}
        dotBorderWidth={2}
        blendMode="multiply"
        motionConfig="wobbly"
        legends={legends}
      />
    </>
  );
}

export default RadarNota;
